import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import TopBar from '../../../layout/TopBar';
import JurisprudenceTabs from '../components/JurisprudenceTabs';
import AlertFilters from '../components/AlertFilters';
import AlertsTable from '../components/AlertsTable';
import AlertDetailModal from '../components/AlertDetailModal';
import { useJurisprudenceAlerts, JurisprudenceAlertItem } from '../hooks/useJurisprudenceAlerts';

const summaryCard =
  'bg-white dark:bg-mcdm-third-400 border border-gray-200 dark:border-gray-700 rounded-lg p-4';
const summaryLabel =
  'text-xs uppercase tracking-wide text-mcdm-third-500 dark:text-mcdm-primary-200';
const summaryValue = 'text-2xl font-semibold text-mcdm-third-500 dark:text-mcdm-primary-100 mt-1';

const AlertsCenterPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const initialSuiviId = searchParams.get('suiviId') ?? undefined;
  const {
    alerts,
    summary,
    filters,
    isLoading,
    error,
    page,
    totalPages,
    total,
    applyFilters,
    goToPage,
  } = useJurisprudenceAlerts(20);

  const [selectedAlert, setSelectedAlert] = useState<JurisprudenceAlertItem | null>(null);

  useEffect(() => {
    if (initialSuiviId && !filters.suiviId) {
      applyFilters({ ...filters, suiviId: initialSuiviId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSuiviId]);

  return (
    <div className="min-h-screen bg-mcdm-primary-200 dark:bg-mcdm-third-500 pb-10">
      <TopBar />
      <div className="pt-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:justify-between sm:items-center mb-6">
            <h1 className="text-2xl font-platypi text-mcdm-third-500 dark:text-mcdm-primary-100">
              Jurisprudences
            </h1>
          </div>

          <JurisprudenceTabs active="alerts" />

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4">
            <div className={summaryCard}>
              <p className={summaryLabel}>Total</p>
              <p className={summaryValue}>{summary?.total ?? '—'}</p>
            </div>
            <div className={summaryCard}>
              <p className={summaryLabel}>Envoyées</p>
              <p className={summaryValue}>{summary?.byStatus.sent ?? '—'}</p>
            </div>
            <div className={summaryCard}>
              <p className={summaryLabel}>En attente</p>
              <p className={summaryValue}>{summary?.byStatus.pending ?? '—'}</p>
            </div>
            <div className={summaryCard}>
              <p className={summaryLabel}>Échecs</p>
              <p className={summaryValue}>{summary?.byStatus.failed ?? '—'}</p>
            </div>
          </div>

          <AlertFilters value={filters} onChange={applyFilters} onReset={() => applyFilters({})} />

          {error && (
            <div className="bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-700 text-red-700 dark:text-red-200 rounded-md px-4 py-3 mb-4 text-sm">
              Erreur de chargement : {error}
            </div>
          )}

          <AlertsTable
            alerts={alerts}
            isLoading={isLoading}
            total={total}
            page={page}
            totalPages={totalPages}
            onPageChange={goToPage}
            onRowClick={setSelectedAlert}
          />
        </div>
      </div>

      {selectedAlert && (
        <AlertDetailModal alert={selectedAlert} onClose={() => setSelectedAlert(null)} />
      )}
    </div>
  );
};

export default AlertsCenterPage;
